import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import logo from '../../assets/images/logo.png';
import logoutIcon from '../../assets/images/logout-icon.png';
import { INDEX_URL } from '../../utils/constants';

const Header = () => {
  const { user } = useAuth();
  const { logout } = useAuth();
  const navigate = useNavigate();

  

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    navigate('/login', { replace: true }); // Redirect to login page
  };
  return (
    <React.Fragment>
      <header className="headerSection trs">
        
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container">
              <a href={INDEX_URL}><img src={logo} alt="Techtop" className="navbar-brand" /></a>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav"  aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav">
                  <li>
                    <a href={`${INDEX_URL}`} className="nav-link">News</a>
                  </li> 
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownTools" role="button" data-bs-toggle="dropdown" aria-expanded="false">Tools</a>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdownTools">
                      <li><a className="dropdown-item" href={`${INDEX_URL}net-price-report`}>Net Price Sheet</a></li>
                      <li><a className="dropdown-item" href={`${INDEX_URL}quote-me`}>Quote Me</a></li>
                      <li><a className="dropdown-item" href={`${INDEX_URL}account-multiplier-form`}>New Account Multiplier Form</a></li>
                      <li><a className="dropdown-item" href={`${INDEX_URL}csr-open-orders`}>CSR Open Orders</a></li>
                      <li><a className="dropdown-item" href={`${INDEX_URL}techtop-training`}>Techtop Training</a></li>
                      <li><a className="dropdown-item" href={`${INDEX_URL}distributor-lookup`}>Distributor Lookup</a></li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Reports</a>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      {user.user_type === 'admin' && (<li><a className="dropdown-item" href={`${INDEX_URL}sales-report`}>Sales</a></li>)}
                      <li><a className="dropdown-item" href={`${INDEX_URL}territory-multiplier-report`}>Territory Multiplier</a></li>
                      <li><a className="dropdown-item" href={`${INDEX_URL}sales-trending-report`}>Sales Trending</a></li>
                      <li><a className="dropdown-item" href={`${INDEX_URL}year-end-bonus`}>2026 Year End Bonus</a></li>
                    </ul>
                  </li>
                  <li>
                    <a href={`${INDEX_URL}`} onClick={handleLogout} className="qc-logout-txt nav-link">
                    <img src={logoutIcon} alt="Logout" className="img-fluid" /> Logout</a>
                  </li> 

                </ul>
              </div>
            </div>
          </nav>
          {/* <div className="row">
            <div className="col-6">
              <a href={INDEX_URL}><img src={logo} alt="Techtop" className="d-block img-fluid" /></a>
            </div>
            <div className="col-6 align-self-center">
              <ul className="techtop-right-menu">
                <li>
                  <a href={`${INDEX_URL}`} className="nav-item">News</a>
                </li> 
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownTools" role="button" data-bs-toggle="dropdown" aria-expanded="false">Tools</a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdownTools">
                    <li><a className="dropdown-item" href={`${INDEX_URL}net-price-report`}>Net Price Sheet</a></li>
                    <li><a className="dropdown-item" href={`${INDEX_URL}quote-me`}>Quote Me</a></li>
                    <li><a className="dropdown-item" href={`${INDEX_URL}account-multiplier-form`}>New Account Multiplier Form</a></li>
                    <li><a className="dropdown-item" href={`${INDEX_URL}csr-open-orders`}>CSR Open Orders</a></li>
                    <li><a className="dropdown-item" href={`${INDEX_URL}techtop-training`}>Techtop Training</a></li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Reports</a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    {user.user_type === 'admin' && (<li><a className="dropdown-item" href={`${INDEX_URL}sales-report`}>Sales</a></li>)}
                    <li><a className="dropdown-item" href={`${INDEX_URL}territory-multiplier-report`}>Territory Multiplier</a></li>
                    <li><a className="dropdown-item" href={`${INDEX_URL}sales-trending-report`}>Sales Trending</a></li>
                    <li><a className="dropdown-item" href={`${INDEX_URL}year-end-bonus`}>2026 Year End Bonus</a></li>
                  </ul>
                </li>
                <li>
                  <a href={`${INDEX_URL}`} onClick={handleLogout} className="qc-logout-txt">
                  <img src={logoutIcon} alt="Logout" className="img-fluid" /> Logout</a>
                </li>             
              </ul> 
            </div>
          </div> */}
        
      </header>
    </React.Fragment>
  );
};

export default Header;